export default "__VITE_ASSET__614f266c__"